import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购出库结果单列表
    { key: 'getStockoutResults', url: 'stockout-results', method: 'GET' },
    // 采购出库单明细
    { key: 'getStockoutResultsDetail', url: 'stockout-results/detail', method: 'GET' },
    // 采购出库单确定入库
    {
      key: 'generateResultsByStockout',
      url: 'stockout-results/generate-results-by-stockout',
      method: 'POST',
    },
    // 采购出库结果单导出
    { key: 'reportResultsByStockout', url: 'stockout-results/report', method: 'GET', rType: 2 },
  ],
};
export default {
  ...generate(config),
};
